// src/types/index.ts
var TrackClassification = /* @__PURE__ */ ((TrackClassification2) => {
  TrackClassification2["UNKNOWN"] = "UNKNOWN";
  TrackClassification2["DRONE_SMALL"] = "DRONE_SMALL";
  TrackClassification2["DRONE_MEDIUM"] = "DRONE_MEDIUM";
  TrackClassification2["DRONE_LARGE"] = "DRONE_LARGE";
  TrackClassification2["AIRCRAFT_GENERAL"] = "AIRCRAFT_GENERAL";
  TrackClassification2["AIRCRAFT_COMMERCIAL"] = "AIRCRAFT_COMMERCIAL";
  TrackClassification2["HELICOPTER"] = "HELICOPTER";
  TrackClassification2["BIRD"] = "BIRD";
  TrackClassification2["WEATHER"] = "WEATHER";
  TrackClassification2["CLUTTER"] = "CLUTTER";
  return TrackClassification2;
})(TrackClassification || {});
var SensorType = /* @__PURE__ */ ((SensorType2) => {
  SensorType2["RADAR"] = "RADAR";
  SensorType2["RF_DETECTOR"] = "RF_DETECTOR";
  SensorType2["ACOUSTIC"] = "ACOUSTIC";
  SensorType2["OPTICAL"] = "OPTICAL";
  SensorType2["ADS_B"] = "ADS_B";
  SensorType2["MULTI_SENSOR"] = "MULTI_SENSOR";
  SensorType2["MANUAL"] = "MANUAL";
  return SensorType2;
})(SensorType || {});
var DataFormat = /* @__PURE__ */ ((DataFormat2) => {
  DataFormat2["SAPIENT"] = "SAPIENT";
  DataFormat2["COT"] = "COT";
  DataFormat2["ADS_B"] = "ADS_B";
  DataFormat2["DUMP"] = "DUMP";
  DataFormat2["JSON_CUSTOM"] = "JSON_CUSTOM";
  return DataFormat2;
})(DataFormat || {});
var GeofenceType = /* @__PURE__ */ ((GeofenceType2) => {
  GeofenceType2["INCLUSION"] = "INCLUSION";
  GeofenceType2["EXCLUSION"] = "EXCLUSION";
  GeofenceType2["ALERT"] = "ALERT";
  return GeofenceType2;
})(GeofenceType || {});
var GeofenceState = /* @__PURE__ */ ((GeofenceState2) => {
  GeofenceState2["OUTSIDE"] = "OUTSIDE";
  GeofenceState2["INSIDE"] = "INSIDE";
  GeofenceState2["ENTERING"] = "ENTERING";
  GeofenceState2["EXITING"] = "EXITING";
  return GeofenceState2;
})(GeofenceState || {});
var AlertSeverity = /* @__PURE__ */ ((AlertSeverity2) => {
  AlertSeverity2["INFO"] = "INFO";
  AlertSeverity2["WARNING"] = "WARNING";
  AlertSeverity2["CRITICAL"] = "CRITICAL";
  return AlertSeverity2;
})(AlertSeverity || {});
var MissionStatus = /* @__PURE__ */ ((MissionStatus2) => {
  MissionStatus2["DRAFT"] = "DRAFT";
  MissionStatus2["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  MissionStatus2["APPROVED"] = "APPROVED";
  MissionStatus2["ACTIVE"] = "ACTIVE";
  MissionStatus2["COMPLETED"] = "COMPLETED";
  MissionStatus2["CANCELLED"] = "CANCELLED";
  MissionStatus2["ABORTED"] = "ABORTED";
  return MissionStatus2;
})(MissionStatus || {});
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["SUPER_ADMIN"] = "SUPER_ADMIN";
  UserRole2["ADMIN"] = "ADMIN";
  UserRole2["OPERATOR"] = "OPERATOR";
  UserRole2["ANALYST"] = "ANALYST";
  UserRole2["VIEWER"] = "VIEWER";
  return UserRole2;
})(UserRole || {});
var SubscriptionTier = /* @__PURE__ */ ((SubscriptionTier2) => {
  SubscriptionTier2["FREE"] = "FREE";
  SubscriptionTier2["STARTER"] = "STARTER";
  SubscriptionTier2["PROFESSIONAL"] = "PROFESSIONAL";
  SubscriptionTier2["ENTERPRISE"] = "ENTERPRISE";
  return SubscriptionTier2;
})(SubscriptionTier || {});
var AirspaceClass = /* @__PURE__ */ ((AirspaceClass2) => {
  AirspaceClass2["A"] = "A";
  AirspaceClass2["B"] = "B";
  AirspaceClass2["C"] = "C";
  AirspaceClass2["D"] = "D";
  AirspaceClass2["E"] = "E";
  AirspaceClass2["G"] = "G";
  return AirspaceClass2;
})(AirspaceClass || {});
var WaypointAction = /* @__PURE__ */ ((WaypointAction2) => {
  WaypointAction2["FLYTHROUGH"] = "FLYTHROUGH";
  WaypointAction2["LOITER"] = "LOITER";
  WaypointAction2["TAKEOFF"] = "TAKEOFF";
  WaypointAction2["LAND"] = "LAND";
  WaypointAction2["RTL"] = "RTL";
  return WaypointAction2;
})(WaypointAction || {});
var AirspaceType = /* @__PURE__ */ ((AirspaceType2) => {
  AirspaceType2["CLASS_AIRSPACE"] = "CLASS_AIRSPACE";
  AirspaceType2["RESTRICTED"] = "RESTRICTED";
  AirspaceType2["PROHIBITED"] = "PROHIBITED";
  AirspaceType2["WARNING"] = "WARNING";
  AirspaceType2["ALERT"] = "ALERT";
  AirspaceType2["MOA"] = "MOA";
  AirspaceType2["TFR"] = "TFR";
  AirspaceType2["STADIUM"] = "STADIUM";
  AirspaceType2["NATIONAL_PARK"] = "NATIONAL_PARK";
  AirspaceType2["UAS_FACILITY"] = "UAS_FACILITY";
  return AirspaceType2;
})(AirspaceType || {});
var FacilityType = /* @__PURE__ */ ((FacilityType2) => {
  FacilityType2["AIRPORT"] = "AIRPORT";
  FacilityType2["HELIPORT"] = "HELIPORT";
  FacilityType2["SEAPLANE_BASE"] = "SEAPLANE_BASE";
  FacilityType2["CONTROL_TOWER"] = "CONTROL_TOWER";
  FacilityType2["TRACON"] = "TRACON";
  FacilityType2["ARTCC"] = "ARTCC";
  return FacilityType2;
})(FacilityType || {});
var SensorStatus = /* @__PURE__ */ ((SensorStatus2) => {
  SensorStatus2["ONLINE"] = "ONLINE";
  SensorStatus2["OFFLINE"] = "OFFLINE";
  SensorStatus2["DEGRADED"] = "DEGRADED";
  SensorStatus2["MAINTENANCE"] = "MAINTENANCE";
  return SensorStatus2;
})(SensorStatus || {});
var AlertType = /* @__PURE__ */ ((AlertType2) => {
  AlertType2["GEOFENCE_BREACH"] = "GEOFENCE_BREACH";
  AlertType2["AIRSPACE_INTRUSION"] = "AIRSPACE_INTRUSION";
  AlertType2["TRACK_LOST"] = "TRACK_LOST";
  AlertType2["SENSOR_OFFLINE"] = "SENSOR_OFFLINE";
  AlertType2["MISSION_DEVIATION"] = "MISSION_DEVIATION";
  AlertType2["SYSTEM_WARNING"] = "SYSTEM_WARNING";
  AlertType2["RISK_THRESHOLD"] = "RISK_THRESHOLD";
  return AlertType2;
})(AlertType || {});
var ApiPermission = /* @__PURE__ */ ((ApiPermission2) => {
  ApiPermission2["READ_TRACKS"] = "READ_TRACKS";
  ApiPermission2["WRITE_TRACKS"] = "WRITE_TRACKS";
  ApiPermission2["READ_MISSIONS"] = "READ_MISSIONS";
  ApiPermission2["WRITE_MISSIONS"] = "WRITE_MISSIONS";
  ApiPermission2["READ_GEOFENCES"] = "READ_GEOFENCES";
  ApiPermission2["WRITE_GEOFENCES"] = "WRITE_GEOFENCES";
  ApiPermission2["READ_ANALYTICS"] = "READ_ANALYTICS";
  ApiPermission2["ADMIN"] = "ADMIN";
  return ApiPermission2;
})(ApiPermission || {});
var ReportType = /* @__PURE__ */ ((ReportType2) => {
  ReportType2["TRACK_SUMMARY"] = "TRACK_SUMMARY";
  ReportType2["ACTIVITY_HEATMAP"] = "ACTIVITY_HEATMAP";
  ReportType2["TREND_ANALYSIS"] = "TREND_ANALYSIS";
  ReportType2["COMPLIANCE_AUDIT"] = "COMPLIANCE_AUDIT";
  ReportType2["MISSION_SUMMARY"] = "MISSION_SUMMARY";
  ReportType2["RISK_ASSESSMENT"] = "RISK_ASSESSMENT";
  return ReportType2;
})(ReportType || {});
var WebSocketMessageType = /* @__PURE__ */ ((WebSocketMessageType2) => {
  WebSocketMessageType2["TRACK_UPDATE"] = "TRACK_UPDATE";
  WebSocketMessageType2["TRACK_NEW"] = "TRACK_NEW";
  WebSocketMessageType2["TRACK_LOST"] = "TRACK_LOST";
  WebSocketMessageType2["ALERT_NEW"] = "ALERT_NEW";
  WebSocketMessageType2["ALERT_CLEARED"] = "ALERT_CLEARED";
  WebSocketMessageType2["SENSOR_STATUS"] = "SENSOR_STATUS";
  WebSocketMessageType2["MISSION_UPDATE"] = "MISSION_UPDATE";
  WebSocketMessageType2["HEARTBEAT"] = "HEARTBEAT";
  WebSocketMessageType2["ERROR"] = "ERROR";
  return WebSocketMessageType2;
})(WebSocketMessageType || {});

// src/schemas/index.ts
import { z } from "zod";
var uuidSchema = z.string().uuid();
var latitudeSchema = z.number().min(-90).max(90);
var longitudeSchema = z.number().min(-180).max(180);
var altitudeSchema = z.number().min(-1e3).max(1e5);
var headingSchema = z.number().min(0).max(360);
var speedSchema = z.number().min(0).max(1e3);
var confidenceSchema = z.number().min(0).max(1);
var dateSchema = z.coerce.date();
var paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(1e3).default(50)
});
var timeRangeSchema = z.object({
  startTime: dateSchema,
  endTime: dateSchema
}).refine((data) => data.startTime < data.endTime, {
  message: "startTime must be before endTime"
});
var trackClassificationSchema = z.nativeEnum(TrackClassification);
var sensorTypeSchema = z.nativeEnum(SensorType);
var dataFormatSchema = z.nativeEnum(DataFormat);
var trackPositionSchema = z.object({
  trackId: uuidSchema,
  tenantId: uuidSchema,
  timestamp: dateSchema,
  latitude: latitudeSchema,
  longitude: longitudeSchema,
  altitudeMSL: altitudeSchema,
  groundSpeed: speedSchema,
  heading: headingSchema,
  classification: trackClassificationSchema,
  confidence: confidenceSchema
});
var canonicalTrackSchema = z.object({
  trackId: uuidSchema,
  tenantId: uuidSchema,
  sensorId: uuidSchema,
  externalId: z.string().optional(),
  timestamp: dateSchema,
  firstSeen: dateSchema,
  lastSeen: dateSchema,
  latitude: latitudeSchema,
  longitude: longitudeSchema,
  altitudeMSL: altitudeSchema,
  altitudeAGL: altitudeSchema.optional(),
  altitudeAccuracy: z.number().positive().optional(),
  groundSpeed: speedSchema,
  verticalSpeed: z.number().optional(),
  heading: headingSchema,
  course: headingSchema.optional(),
  classification: trackClassificationSchema,
  confidence: confidenceSchema,
  callsign: z.string().max(10).optional(),
  icaoAddress: z.string().regex(/^[0-9A-F]{6}$/).optional(),
  registration: z.string().max(10).optional(),
  model: z.string().max(100).optional(),
  manufacturer: z.string().max(100).optional(),
  serialNumber: z.string().max(100).optional(),
  sensorType: sensorTypeSchema,
  dataFormat: dataFormatSchema,
  rawPayloadRef: z.string().optional(),
  geofenceStates: z.array(z.object({
    geofenceId: uuidSchema,
    geofenceName: z.string(),
    state: z.enum(["OUTSIDE", "INSIDE", "ENTERING", "EXITING"]),
    enteredAt: dateSchema.optional(),
    exitedAt: dateSchema.optional()
  })),
  riskScore: z.number().min(0).max(100).optional(),
  riskFactors: z.array(z.string()).optional()
});
var trackQuerySchema = z.object({
  tenantId: uuidSchema.optional(),
  sensorId: uuidSchema.optional(),
  classification: trackClassificationSchema.optional(),
  minConfidence: confidenceSchema.optional(),
  boundingBox: z.object({
    minLat: latitudeSchema,
    maxLat: latitudeSchema,
    minLng: longitudeSchema,
    maxLng: longitudeSchema
  }).optional(),
  geofenceId: uuidSchema.optional(),
  startTime: dateSchema.optional(),
  endTime: dateSchema.optional(),
  // Identity-based search filters
  model: z.string().max(100).optional(),
  manufacturer: z.string().max(100).optional(),
  serialNumber: z.string().max(100).optional(),
  registration: z.string().max(10).optional()
}).merge(paginationSchema);
var ingestTrackSchema = z.object({
  sensorId: uuidSchema,
  dataFormat: dataFormatSchema,
  payload: z.union([z.string(), z.record(z.unknown())]),
  receivedAt: dateSchema.optional()
});
var sapientDetectionSchema = z.object({
  reportId: z.string(),
  timestamp: z.string().datetime(),
  sourceId: z.string(),
  objectId: z.string(),
  state: z.string(),
  location: z.object({
    x: z.number(),
    y: z.number(),
    z: z.number().optional(),
    xError: z.number().optional(),
    yError: z.number().optional(),
    zError: z.number().optional()
  }),
  velocity: z.object({
    x: z.number().optional(),
    y: z.number().optional(),
    z: z.number().optional()
  }).optional(),
  classification: z.object({
    type: z.string(),
    confidence: z.number()
  }).optional()
});
var cotMessageSchema = z.object({
  event: z.object({
    type: z.string(),
    uid: z.string(),
    time: z.string(),
    start: z.string(),
    stale: z.string(),
    how: z.string().optional(),
    point: z.object({
      lat: latitudeSchema,
      lon: longitudeSchema,
      hae: altitudeSchema.optional(),
      ce: z.number().optional(),
      le: z.number().optional()
    }),
    detail: z.record(z.unknown()).optional()
  })
});
var adsbMessageSchema = z.object({
  hex: z.string().regex(/^[0-9A-Fa-f]{6}$/),
  type: z.string().optional(),
  flight: z.string().optional(),
  lat: latitudeSchema.optional(),
  lon: longitudeSchema.optional(),
  altitude: z.number().optional(),
  speed: z.number().optional(),
  track: headingSchema.optional(),
  vert_rate: z.number().optional(),
  category: z.string().optional(),
  squawk: z.string().optional(),
  emergency: z.string().optional(),
  spi: z.boolean().optional(),
  seen: z.number().optional(),
  seen_pos: z.number().optional(),
  rssi: z.number().optional()
});
var geofenceTypeSchema = z.nativeEnum(GeofenceType);
var alertSeveritySchema = z.nativeEnum(AlertSeverity);
var geoJSONPolygonSchema = z.object({
  type: z.literal("Polygon"),
  coordinates: z.array(z.array(z.tuple([longitudeSchema, latitudeSchema])))
});
var geoJSONCircleSchema = z.object({
  type: z.literal("Circle"),
  center: z.tuple([longitudeSchema, latitudeSchema]),
  radiusMeters: z.number().positive().max(1e5)
});
var geofenceGeometrySchema = z.union([geoJSONPolygonSchema, geoJSONCircleSchema]);
var createGeofenceSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().max(500).optional(),
  type: geofenceTypeSchema,
  geometry: geofenceGeometrySchema,
  altitudeMin: altitudeSchema.optional(),
  altitudeMax: altitudeSchema.optional(),
  activeFrom: dateSchema.optional(),
  activeTo: dateSchema.optional(),
  isActive: z.boolean().default(true),
  alertSeverity: alertSeveritySchema.default("WARNING" /* WARNING */),
  notifyOnEntry: z.boolean().default(true),
  notifyOnExit: z.boolean().default(false),
  notifyUserIds: z.array(uuidSchema).default([]),
  metadata: z.record(z.unknown()).optional()
});
var updateGeofenceSchema = createGeofenceSchema.partial();
var missionStatusSchema = z.nativeEnum(MissionStatus);
var waypointActionSchema = z.nativeEnum(WaypointAction);
var missionWaypointSchema = z.object({
  id: uuidSchema.optional(),
  sequence: z.number().int().min(0),
  name: z.string().max(50).optional(),
  latitude: latitudeSchema,
  longitude: longitudeSchema,
  altitudeMSL: altitudeSchema,
  altitudeAGL: altitudeSchema.optional(),
  speedMps: speedSchema.optional(),
  loiterTimeSeconds: z.number().int().min(0).optional(),
  action: waypointActionSchema.default("FLYTHROUGH" /* FLYTHROUGH */)
});
var missionRouteSchema = z.object({
  waypoints: z.array(missionWaypointSchema).min(2),
  corridorWidthMeters: z.number().positive().max(1e4).default(100),
  totalDistanceMeters: z.number().positive().optional(),
  estimatedDurationSeconds: z.number().positive().optional()
});
var baseMissionSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().max(1e3).optional(),
  route: missionRouteSchema,
  plannedStartTime: dateSchema,
  plannedEndTime: dateSchema,
  aircraftType: z.string().max(100).optional(),
  aircraftRegistration: z.string().max(20).optional(),
  pilotId: uuidSchema.optional()
});
var createMissionSchema = baseMissionSchema.refine(
  (data) => data.plannedStartTime < data.plannedEndTime,
  {
    message: "plannedStartTime must be before plannedEndTime"
  }
);
var updateMissionSchema = baseMissionSchema.partial().extend({
  status: missionStatusSchema.optional()
});
var validateMissionSchema = z.object({
  missionId: uuidSchema,
  validateAgainst: z.array(z.enum(["AIRSPACE", "GEOFENCES", "WEATHER", "HISTORICAL_RISK"])).default(["AIRSPACE", "GEOFENCES"])
});
var userRoleSchema = z.nativeEnum(UserRole);
var createUserSchema = z.object({
  email: z.string().email(),
  firstName: z.string().min(1).max(50),
  lastName: z.string().min(1).max(50),
  role: userRoleSchema.default("VIEWER" /* VIEWER */),
  password: z.string().min(12).max(128)
});
var updateUserSchema = z.object({
  firstName: z.string().min(1).max(50).optional(),
  lastName: z.string().min(1).max(50).optional(),
  role: userRoleSchema.optional(),
  avatarUrl: z.string().url().optional(),
  preferences: z.object({
    theme: z.enum(["LIGHT", "DARK", "SYSTEM"]).optional(),
    notifications: z.object({
      emailAlerts: z.boolean().optional(),
      geofenceAlerts: z.boolean().optional(),
      missionAlerts: z.boolean().optional(),
      systemAlerts: z.boolean().optional()
    }).optional(),
    dashboard: z.object({
      defaultView: z.enum(["MAP", "ANALYTICS", "MISSIONS"]).optional(),
      mapStyle: z.enum(["SATELLITE", "TERRAIN", "DARK", "LIGHT"]).optional(),
      showTrackLabels: z.boolean().optional(),
      showAirspace: z.boolean().optional(),
      showGeofences: z.boolean().optional()
    }).optional()
  }).optional()
});
var loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1)
});
var refreshTokenSchema = z.object({
  refreshToken: z.string().min(1)
});
var subscriptionTierSchema = z.nativeEnum(SubscriptionTier);
var createTenantSchema = z.object({
  name: z.string().min(1).max(100),
  slug: z.string().min(3).max(50).regex(/^[a-z0-9-]+$/),
  domain: z.string().optional(),
  settings: z.object({
    timezone: z.string().default("UTC"),
    dateFormat: z.string().default("YYYY-MM-DD"),
    unitSystem: z.enum(["METRIC", "IMPERIAL"]).default("METRIC"),
    defaultMapCenter: z.tuple([longitudeSchema, latitudeSchema]).default([-98.5795, 39.8283]),
    defaultMapZoom: z.number().min(1).max(20).default(4),
    dataRetentionDays: z.number().int().min(0).default(0)
  }).optional()
});
var updateTenantSchema = createTenantSchema.partial();
var apiPermissionSchema = z.enum([
  "READ_TRACKS",
  "WRITE_TRACKS",
  "READ_MISSIONS",
  "WRITE_MISSIONS",
  "READ_GEOFENCES",
  "WRITE_GEOFENCES",
  "READ_ANALYTICS",
  "ADMIN"
]);
var createApiKeySchema = z.object({
  name: z.string().min(1).max(100),
  permissions: z.array(apiPermissionSchema).min(1),
  rateLimit: z.number().int().min(1).max(1e4).default(100),
  ipAllowlist: z.array(z.string().ip()).optional(),
  expiresAt: dateSchema.optional()
});
var sensorStatusSchema = z.enum(["ONLINE", "OFFLINE", "DEGRADED", "MAINTENANCE"]);
var createSensorSchema = z.object({
  name: z.string().min(1).max(100),
  type: sensorTypeSchema,
  dataFormat: dataFormatSchema,
  location: z.object({
    latitude: latitudeSchema,
    longitude: longitudeSchema,
    altitudeMSL: altitudeSchema.optional(),
    heading: headingSchema.optional(),
    fixedLocation: z.boolean().default(true)
  }).optional(),
  configuration: z.object({
    updateRateHz: z.number().positive().max(100).optional(),
    maxRange: z.number().positive().optional(),
    minRange: z.number().positive().optional(),
    fieldOfView: z.number().positive().max(360).optional(),
    filterSettings: z.record(z.unknown()).optional()
  }).optional()
});
var updateSensorSchema = createSensorSchema.partial().extend({
  status: sensorStatusSchema.optional()
});
var reportTypeSchema = z.enum([
  "TRACK_SUMMARY",
  "ACTIVITY_HEATMAP",
  "TREND_ANALYSIS",
  "COMPLIANCE_AUDIT",
  "MISSION_SUMMARY",
  "RISK_ASSESSMENT"
]);
var createReportSchema = z.object({
  type: reportTypeSchema,
  name: z.string().min(1).max(100),
  parameters: z.object({
    startDate: dateSchema,
    endDate: dateSchema,
    geofenceIds: z.array(uuidSchema).optional(),
    sensorIds: z.array(uuidSchema).optional(),
    classifications: z.array(trackClassificationSchema).optional(),
    includeRawData: z.boolean().default(false)
  })
});
var airspaceClassSchema = z.nativeEnum(AirspaceClass);
var airspaceQuerySchema = z.object({
  boundingBox: z.object({
    minLat: latitudeSchema,
    maxLat: latitudeSchema,
    minLng: longitudeSchema,
    maxLng: longitudeSchema
  }).optional(),
  types: z.array(z.string()).optional(),
  classes: z.array(airspaceClassSchema).optional(),
  includeExpired: z.boolean().default(false)
}).merge(paginationSchema);
var schemas = {
  // Common
  uuid: uuidSchema,
  pagination: paginationSchema,
  timeRange: timeRangeSchema,
  // Tracks
  trackPosition: trackPositionSchema,
  canonicalTrack: canonicalTrackSchema,
  trackQuery: trackQuerySchema,
  // Ingestion
  ingestTrack: ingestTrackSchema,
  sapientDetection: sapientDetectionSchema,
  cotMessage: cotMessageSchema,
  adsbMessage: adsbMessageSchema,
  // Geofences
  createGeofence: createGeofenceSchema,
  updateGeofence: updateGeofenceSchema,
  // Missions
  createMission: createMissionSchema,
  updateMission: updateMissionSchema,
  validateMission: validateMissionSchema,
  // Users
  createUser: createUserSchema,
  updateUser: updateUserSchema,
  login: loginSchema,
  refreshToken: refreshTokenSchema,
  // Tenants
  createTenant: createTenantSchema,
  updateTenant: updateTenantSchema,
  // API Keys
  createApiKey: createApiKeySchema,
  // Sensors
  createSensor: createSensorSchema,
  updateSensor: updateSensorSchema,
  // Analytics
  createReport: createReportSchema,
  // Airspace
  airspaceQuery: airspaceQuerySchema
};

// src/utils/index.ts
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371e3;
  const \u03C61 = lat1 * Math.PI / 180;
  const \u03C62 = lat2 * Math.PI / 180;
  const \u0394\u03C6 = (lat2 - lat1) * Math.PI / 180;
  const \u0394\u03BB = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(\u0394\u03C6 / 2) * Math.sin(\u0394\u03C6 / 2) + Math.cos(\u03C61) * Math.cos(\u03C62) * Math.sin(\u0394\u03BB / 2) * Math.sin(\u0394\u03BB / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
function calculateBearing(lat1, lon1, lat2, lon2) {
  const \u03C61 = lat1 * Math.PI / 180;
  const \u03C62 = lat2 * Math.PI / 180;
  const \u0394\u03BB = (lon2 - lon1) * Math.PI / 180;
  const y = Math.sin(\u0394\u03BB) * Math.cos(\u03C62);
  const x = Math.cos(\u03C61) * Math.sin(\u03C62) - Math.sin(\u03C61) * Math.cos(\u03C62) * Math.cos(\u0394\u03BB);
  const \u03B8 = Math.atan2(y, x);
  return (\u03B8 * 180 / Math.PI + 360) % 360;
}
function calculateDestination(lat, lon, bearing, distance) {
  const R = 6371e3;
  const \u03B4 = distance / R;
  const \u03B8 = bearing * Math.PI / 180;
  const \u03C61 = lat * Math.PI / 180;
  const \u03BB1 = lon * Math.PI / 180;
  const \u03C62 = Math.asin(
    Math.sin(\u03C61) * Math.cos(\u03B4) + Math.cos(\u03C61) * Math.sin(\u03B4) * Math.cos(\u03B8)
  );
  const \u03BB2 = \u03BB1 + Math.atan2(
    Math.sin(\u03B8) * Math.sin(\u03B4) * Math.cos(\u03C61),
    Math.cos(\u03B4) - Math.sin(\u03C61) * Math.sin(\u03C62)
  );
  return {
    latitude: \u03C62 * 180 / Math.PI,
    longitude: \u03BB2 * 180 / Math.PI
  };
}
function metersToFeet(meters) {
  return meters * 3.28084;
}
function feetToMeters(feet) {
  return feet / 3.28084;
}
function mpsToKnots(mps) {
  return mps * 1.94384;
}
function knotsToMps(knots) {
  return knots / 1.94384;
}
function pointInPolygon(point, polygon) {
  const [x, y] = point;
  let inside = false;
  for (const ring of polygon) {
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
      const [xi, yi] = ring[i];
      const [xj, yj] = ring[j];
      if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) {
        inside = !inside;
      }
    }
  }
  return inside;
}
function pointInCircle(point, center, radiusMeters) {
  const distance = calculateDistance(point[1], point[0], center[1], center[0]);
  return distance <= radiusMeters;
}
function getBoundingBox(lat, lng, radiusMeters) {
  const latDelta = radiusMeters / 111320;
  const lngDelta = radiusMeters / (111320 * Math.cos(lat * Math.PI / 180));
  return {
    minLat: lat - latDelta,
    maxLat: lat + latDelta,
    minLng: lng - lngDelta,
    maxLng: lng + lngDelta
  };
}
function formatCoordinates(lat, lng, format = "DD") {
  if (format === "DD") {
    return `${lat.toFixed(6)}\xB0, ${lng.toFixed(6)}\xB0`;
  }
  const latDir = lat >= 0 ? "N" : "S";
  const lngDir = lng >= 0 ? "E" : "W";
  const formatDMS = (value) => {
    const absValue = Math.abs(value);
    const degrees = Math.floor(absValue);
    const minutes = Math.floor((absValue - degrees) * 60);
    const seconds = ((absValue - degrees - minutes / 60) * 3600).toFixed(2);
    return `${degrees}\xB0 ${minutes}' ${seconds}"`;
  };
  return `${formatDMS(lat)} ${latDir}, ${formatDMS(lng)} ${lngDir}`;
}
function parseDuration(duration) {
  const match = duration.match(
    /P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?/
  );
  if (!match) return 0;
  const [, days, hours, minutes, seconds] = match;
  return parseInt(days || "0") * 86400 + parseInt(hours || "0") * 3600 + parseInt(minutes || "0") * 60 + parseFloat(seconds || "0");
}
function formatDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const secs = Math.floor(seconds % 60);
  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);
  return parts.join(" ");
}
function generateTrackId() {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 10);
  return `TRK-${timestamp}-${randomPart}`.toUpperCase();
}
function slugify(text) {
  return text.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
function truncate(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + "...";
}
function deepMerge(target, source) {
  const output = { ...target };
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
      if (target[key] && typeof target[key] === "object") {
        output[key] = deepMerge(
          target[key],
          source[key]
        );
      } else {
        output[key] = source[key];
      }
    } else if (source[key] !== void 0) {
      output[key] = source[key];
    }
  }
  return output;
}
function debounce(func, wait) {
  let timeout = null;
  return (...args) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}
function throttle(func, limit) {
  let inThrottle = false;
  return (...args) => {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
async function retryWithBackoff(fn, maxRetries = 3, baseDelay = 1e3) {
  let lastError;
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (i < maxRetries - 1) {
        const delay = baseDelay * Math.pow(2, i);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }
  throw lastError;
}
function chunk(array, size) {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}
function groupBy(array, keyFn) {
  return array.reduce((groups, item) => {
    const key = keyFn(item);
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
    return groups;
  }, {});
}
function calculateCentroid(coordinates) {
  const ring = coordinates[0];
  let sumX = 0;
  let sumY = 0;
  for (const [x, y] of ring) {
    sumX += x;
    sumY += y;
  }
  return [sumX / ring.length, sumY / ring.length];
}
function calculatePolygonArea(coordinates) {
  const ring = coordinates[0];
  let area = 0;
  for (let i = 0; i < ring.length - 1; i++) {
    const [x1, y1] = ring[i];
    const [x2, y2] = ring[i + 1];
    area += (x2 - x1) * (y2 + y1);
  }
  const latCenter = ring.reduce((sum, [, lat]) => sum + lat, 0) / ring.length;
  const metersPerDegreeLat = 111320;
  const metersPerDegreeLng = 111320 * Math.cos(latCenter * Math.PI / 180);
  return Math.abs(area / 2) * metersPerDegreeLat * metersPerDegreeLng;
}

// src/constants/index.ts
var LIMITS = {
  // Pagination
  MAX_PAGE_SIZE: 1e3,
  DEFAULT_PAGE_SIZE: 50,
  // Geofences
  MAX_GEOFENCES_PER_TENANT: 500,
  MAX_GEOFENCE_VERTICES: 1e3,
  MAX_GEOFENCE_RADIUS_METERS: 1e5,
  // Missions
  MAX_WAYPOINTS_PER_MISSION: 500,
  MAX_CORRIDOR_WIDTH_METERS: 1e4,
  MAX_MISSION_DURATION_HOURS: 24,
  // Tracks
  MAX_TRACK_HISTORY_DAYS: 365,
  TRACK_STALE_THRESHOLD_SECONDS: 60,
  TRACK_LOST_THRESHOLD_SECONDS: 300,
  // API
  MAX_API_KEYS_PER_TENANT: 50,
  DEFAULT_RATE_LIMIT: 100,
  // per minute
  MAX_RATE_LIMIT: 1e4,
  // Users
  MAX_USERS_FREE: 3,
  MAX_USERS_STARTER: 10,
  MAX_USERS_PROFESSIONAL: 50,
  MAX_USERS_ENTERPRISE: 500,
  // Sensors
  MAX_SENSORS_FREE: 2,
  MAX_SENSORS_STARTER: 10,
  MAX_SENSORS_PROFESSIONAL: 50,
  MAX_SENSORS_ENTERPRISE: 500,
  // Storage
  MAX_RAW_PAYLOAD_SIZE_MB: 10,
  MAX_REPORT_SIZE_MB: 100
};
var SUBSCRIPTION_FEATURES = {
  FREE: {
    maxSensors: 2,
    maxUsers: 3,
    maxApiCalls: 1e3,
    maxDataStorage: 1,
    // GB
    missionPlanning: false,
    analytics: false,
    aiRiskScoring: false,
    cotExport: false,
    apiAccess: false,
    customGeofences: true
  },
  STARTER: {
    maxSensors: 10,
    maxUsers: 10,
    maxApiCalls: 1e4,
    maxDataStorage: 10,
    missionPlanning: true,
    analytics: true,
    aiRiskScoring: false,
    cotExport: false,
    apiAccess: true,
    customGeofences: true
  },
  PROFESSIONAL: {
    maxSensors: 50,
    maxUsers: 50,
    maxApiCalls: 1e5,
    maxDataStorage: 100,
    missionPlanning: true,
    analytics: true,
    aiRiskScoring: true,
    cotExport: true,
    apiAccess: true,
    customGeofences: true
  },
  ENTERPRISE: {
    maxSensors: 500,
    maxUsers: 500,
    maxApiCalls: 1e6,
    maxDataStorage: 1e3,
    missionPlanning: true,
    analytics: true,
    aiRiskScoring: true,
    cotExport: true,
    apiAccess: true,
    customGeofences: true
  }
};
var ROLE_PERMISSIONS = {
  SUPER_ADMIN: [
    "system:*",
    "tenant:*",
    "user:*",
    "track:*",
    "mission:*",
    "geofence:*",
    "sensor:*",
    "analytics:*",
    "billing:*",
    "apikey:*"
  ],
  ADMIN: [
    "tenant:read",
    "tenant:update",
    "user:*",
    "track:*",
    "mission:*",
    "geofence:*",
    "sensor:*",
    "analytics:*",
    "billing:read",
    "apikey:*"
  ],
  OPERATOR: [
    "track:read",
    "track:write",
    "mission:*",
    "geofence:read",
    "geofence:write",
    "sensor:read",
    "analytics:read"
  ],
  ANALYST: [
    "track:read",
    "mission:read",
    "geofence:read",
    "sensor:read",
    "analytics:*"
  ],
  VIEWER: [
    "track:read",
    "mission:read",
    "geofence:read",
    "sensor:read"
  ]
};
var API_ROUTES = {
  // Auth
  AUTH_LOGIN: "/api/v1/auth/login",
  AUTH_LOGOUT: "/api/v1/auth/logout",
  AUTH_REFRESH: "/api/v1/auth/refresh",
  AUTH_ME: "/api/v1/auth/me",
  // Tracks
  TRACKS: "/api/v1/tracks",
  TRACKS_LIVE: "/api/v1/tracks/live",
  TRACKS_HISTORY: "/api/v1/tracks/history",
  // Missions
  MISSIONS: "/api/v1/missions",
  MISSIONS_VALIDATE: "/api/v1/missions/validate",
  MISSIONS_EXPORT: "/api/v1/missions/export",
  // Geofences
  GEOFENCES: "/api/v1/geofences",
  // Sensors
  SENSORS: "/api/v1/sensors",
  // Airspace
  AIRSPACE: "/api/v1/airspace",
  AIRSPACE_FACILITIES: "/api/v1/airspace/facilities",
  // Analytics
  ANALYTICS_REPORTS: "/api/v1/analytics/reports",
  ANALYTICS_STATS: "/api/v1/analytics/stats",
  ANALYTICS_HEATMAP: "/api/v1/analytics/heatmap",
  // Users
  USERS: "/api/v1/users",
  // Tenants
  TENANTS: "/api/v1/tenants",
  // API Keys
  API_KEYS: "/api/v1/api-keys",
  // Billing
  BILLING: "/api/v1/billing",
  BILLING_USAGE: "/api/v1/billing/usage",
  BILLING_INVOICES: "/api/v1/billing/invoices",
  // Ingest
  INGEST: "/api/v1/ingest",
  INGEST_SAPIENT: "/api/v1/ingest/sapient",
  INGEST_COT: "/api/v1/ingest/cot",
  INGEST_ADSB: "/api/v1/ingest/adsb",
  // WebSocket
  WS_TRACKS: "/ws/tracks",
  WS_ALERTS: "/ws/alerts",
  // CoT
  COT_STREAM: "/api/v1/cot/stream"
};
var WS_EVENTS = {
  // Connection
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  ERROR: "error",
  RECONNECT: "reconnect",
  // Subscriptions
  SUBSCRIBE: "subscribe",
  UNSUBSCRIBE: "unsubscribe",
  // Tracks
  TRACK_UPDATE: "track:update",
  TRACK_NEW: "track:new",
  TRACK_LOST: "track:lost",
  TRACK_BATCH: "track:batch",
  // Alerts
  ALERT_NEW: "alert:new",
  ALERT_CLEARED: "alert:cleared",
  // Sensors
  SENSOR_STATUS: "sensor:status",
  // Missions
  MISSION_UPDATE: "mission:update",
  // System
  HEARTBEAT: "heartbeat"
};
var REDIS_CHANNELS = {
  TRACKS: "airrecon:tracks",
  ALERTS: "airrecon:alerts",
  SENSORS: "airrecon:sensors",
  MISSIONS: "airrecon:missions",
  SYSTEM: "airrecon:system"
};
var REDIS_KEYS = {
  SESSION: (sessionId) => `session:${sessionId}`,
  USER_SESSIONS: (userId) => `user:${userId}:sessions`,
  RATE_LIMIT: (key) => `ratelimit:${key}`,
  TRACK_CACHE: (trackId) => `track:${trackId}`,
  TENANT_TRACKS: (tenantId) => `tenant:${tenantId}:tracks`,
  SENSOR_HEARTBEAT: (sensorId) => `sensor:${sensorId}:heartbeat`
};
var MAP_CONFIG = {
  // Default view
  DEFAULT_CENTER: [-98.5795, 39.8283],
  // Center of USA
  DEFAULT_ZOOM: 4,
  MIN_ZOOM: 2,
  MAX_ZOOM: 20,
  // Track visualization
  TRACK_POINT_SIZE: 8,
  TRACK_TRAIL_LENGTH: 20,
  TRACK_TRAIL_OPACITY: 0.6,
  // Geofence visualization
  GEOFENCE_FILL_OPACITY: 0.2,
  GEOFENCE_STROKE_WIDTH: 2,
  // Colors
  COLORS: {
    TRACK_UNKNOWN: "#808080",
    TRACK_DRONE_SMALL: "#00ff00",
    TRACK_DRONE_MEDIUM: "#ffff00",
    TRACK_DRONE_LARGE: "#ff8800",
    TRACK_AIRCRAFT: "#00ffff",
    TRACK_HELICOPTER: "#0088ff",
    TRACK_BIRD: "#888888",
    GEOFENCE_INCLUSION: "#00ff00",
    GEOFENCE_EXCLUSION: "#ff0000",
    GEOFENCE_ALERT: "#ffff00",
    AIRSPACE_CLASS_A: "#ff0000",
    AIRSPACE_CLASS_B: "#0000ff",
    AIRSPACE_CLASS_C: "#ff00ff",
    AIRSPACE_CLASS_D: "#0088ff",
    AIRSPACE_CLASS_E: "#00ffff",
    AIRSPACE_CLASS_G: "#00ff00",
    MISSION_ROUTE: "#ff8800",
    MISSION_CORRIDOR: "#ff880044",
    MISSION_WAYPOINT: "#ffffff"
  }
};
var DATA_FORMATS = {
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm:ss",
  DATETIME: "YYYY-MM-DD HH:mm:ss",
  DATETIME_ISO: "YYYY-MM-DD'T'HH:mm:ss.SSS'Z'",
  DATETIME_DISPLAY: "MMM D, YYYY h:mm A"
};
var COT = {
  // CoT types
  TYPE_FRIENDLY_GROUND: "a-f-G",
  TYPE_FRIENDLY_AIR: "a-f-A",
  TYPE_HOSTILE_AIR: "a-h-A",
  TYPE_UNKNOWN_AIR: "a-u-A",
  TYPE_NEUTRAL_AIR: "a-n-A",
  // CoT how
  HOW_MACHINE_GPS: "m-g",
  HOW_MACHINE_SENSOR: "m-s",
  HOW_HUMAN_INPUT: "h-e",
  // Default stale time in seconds
  DEFAULT_STALE_SECONDS: 60,
  // CoT XML namespace
  NAMESPACE: "http://www.opengis.net/cot/1.1"
};
var ERROR_CODES = {
  // Authentication
  AUTH_INVALID_CREDENTIALS: "AUTH_INVALID_CREDENTIALS",
  AUTH_TOKEN_EXPIRED: "AUTH_TOKEN_EXPIRED",
  AUTH_TOKEN_INVALID: "AUTH_TOKEN_INVALID",
  AUTH_REFRESH_EXPIRED: "AUTH_REFRESH_EXPIRED",
  AUTH_MFA_REQUIRED: "AUTH_MFA_REQUIRED",
  // Authorization
  FORBIDDEN: "FORBIDDEN",
  INSUFFICIENT_PERMISSIONS: "INSUFFICIENT_PERMISSIONS",
  // Validation
  VALIDATION_ERROR: "VALIDATION_ERROR",
  INVALID_INPUT: "INVALID_INPUT",
  // Resources
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  ALREADY_EXISTS: "ALREADY_EXISTS",
  // Rate limiting
  RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED",
  QUOTA_EXCEEDED: "QUOTA_EXCEEDED",
  // System
  INTERNAL_ERROR: "INTERNAL_ERROR",
  SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
  DATABASE_ERROR: "DATABASE_ERROR",
  // Business logic
  GEOFENCE_LIMIT_EXCEEDED: "GEOFENCE_LIMIT_EXCEEDED",
  MISSION_VALIDATION_FAILED: "MISSION_VALIDATION_FAILED",
  SENSOR_OFFLINE: "SENSOR_OFFLINE",
  SUBSCRIPTION_REQUIRED: "SUBSCRIPTION_REQUIRED",
  FEATURE_NOT_AVAILABLE: "FEATURE_NOT_AVAILABLE"
};

// src/data/cta2063a.ts
var CTA_2063A_MANUFACTURERS = Object.freeze({
  "1581": "DJI",
  "1748": "Autel Robotics",
  "1588": "Parrot",
  "1668": "Skydio",
  "1871": "Camflite",
  "1325": "senseFly",
  "1124": "Yuneec",
  "1742": "Freefly Systems",
  "1869": "Dronetag",
  "1867": "Wingtra",
  "1870": "AgEagle (MicaSense)",
  "1740": "Impossible Aerospace",
  "1744": "Matternet",
  "1872": "Zipline",
  "1873": "Wing (Alphabet)",
  "1741": "Joby Aviation",
  "1743": "Wisk Aero",
  "1875": "Holy Stone"
});
function extractManufacturerCode(serial) {
  if (!serial || typeof serial !== "string") return void 0;
  if (serial.length < 5) return void 0;
  const prefix = serial.slice(0, 4).toUpperCase();
  return /^[A-Z0-9]{4}$/.test(prefix) ? prefix : void 0;
}
function resolveManufacturerName(code) {
  if (!code) return void 0;
  return CTA_2063A_MANUFACTURERS[code.toUpperCase()] ?? code;
}
function manufacturerFromSerial(serial) {
  const code = extractManufacturerCode(serial);
  return resolveManufacturerName(code);
}
export {
  API_ROUTES,
  AirspaceClass,
  AirspaceType,
  AlertSeverity,
  AlertType,
  ApiPermission,
  COT,
  CTA_2063A_MANUFACTURERS,
  DATA_FORMATS,
  DataFormat,
  ERROR_CODES,
  FacilityType,
  GeofenceState,
  GeofenceType,
  LIMITS,
  MAP_CONFIG,
  MissionStatus,
  REDIS_CHANNELS,
  REDIS_KEYS,
  ROLE_PERMISSIONS,
  ReportType,
  SUBSCRIPTION_FEATURES,
  SensorStatus,
  SensorType,
  SubscriptionTier,
  TrackClassification,
  UserRole,
  WS_EVENTS,
  WaypointAction,
  WebSocketMessageType,
  adsbMessageSchema,
  airspaceClassSchema,
  airspaceQuerySchema,
  alertSeveritySchema,
  altitudeSchema,
  apiPermissionSchema,
  calculateBearing,
  calculateCentroid,
  calculateDestination,
  calculateDistance,
  calculatePolygonArea,
  canonicalTrackSchema,
  chunk,
  confidenceSchema,
  cotMessageSchema,
  createApiKeySchema,
  createGeofenceSchema,
  createMissionSchema,
  createReportSchema,
  createSensorSchema,
  createTenantSchema,
  createUserSchema,
  dataFormatSchema,
  dateSchema,
  debounce,
  deepMerge,
  extractManufacturerCode,
  feetToMeters,
  formatCoordinates,
  formatDuration,
  generateTrackId,
  geoJSONCircleSchema,
  geoJSONPolygonSchema,
  geofenceGeometrySchema,
  geofenceTypeSchema,
  getBoundingBox,
  groupBy,
  headingSchema,
  ingestTrackSchema,
  knotsToMps,
  latitudeSchema,
  loginSchema,
  longitudeSchema,
  manufacturerFromSerial,
  metersToFeet,
  missionRouteSchema,
  missionStatusSchema,
  missionWaypointSchema,
  mpsToKnots,
  paginationSchema,
  parseDuration,
  pointInCircle,
  pointInPolygon,
  refreshTokenSchema,
  reportTypeSchema,
  resolveManufacturerName,
  retryWithBackoff,
  sapientDetectionSchema,
  schemas,
  sensorStatusSchema,
  sensorTypeSchema,
  slugify,
  speedSchema,
  subscriptionTierSchema,
  throttle,
  timeRangeSchema,
  trackClassificationSchema,
  trackPositionSchema,
  trackQuerySchema,
  truncate,
  updateGeofenceSchema,
  updateMissionSchema,
  updateSensorSchema,
  updateTenantSchema,
  updateUserSchema,
  userRoleSchema,
  uuidSchema,
  validateMissionSchema,
  waypointActionSchema
};
//# sourceMappingURL=index.mjs.map